module.exports = __webpack_public_path__ + "static/media/dashDesktop.3e611fdb.png";